<template>
    <Breadcrumbs main="Form Widgets" title="Switch" />
    <div class="container-fluid">
        <div class="row">
            <customSwitch />
            <iconsSwitch />
            <uncheckedSwitch />
            <bordersIcons />
            <disabledOutline />
            <variationSwitches />
            <switchSizing />
            <switchIcons />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const customSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/customSwitch.vue"))
const iconsSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/iconsSwitch.vue"))
const uncheckedSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/uncheckedSwitch.vue"))
const bordersIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/bordersIcons.vue"))
const disabledOutline = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/disabledOutline.vue"))
const variationSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/variationSwitches.vue"))
const switchSizing = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/switchSizing.vue"))
const switchIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/switchIcons.vue"))
</script>